import ResellerContainer from './container/ResellerContainer'

// Sync route definition
export default {
  path: '/partners',
  component: ResellerContainer,
}
